
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import authModule from '@/store/auth'
import whitelabelModule from '@/store/whitelabel'
import { TextFieldRules } from '@/utils/enums'
import { compareNested } from '@/utils/utility-manager'
import { Whitelabel } from '@/types/Whitelabel'

@Component({
  name: 'WhitelabelEditor'
})
class WhitelabelEditor extends Vue {
  @Prop() readonly edit?: boolean
  public rules = TextFieldRules
  form: Omit<Whitelabel, '_id'> = {
    name: '',
    legalName: '',
    slug: '',
    url: '',
    logoUrl: '',
    email: '',
    phone: '',
    address: {
      street: '',
      streetNo: '',
      zipCode: undefined,
      city: '',
      countryCode: '',
      location: undefined
    },
    active: false,
    settings: {
      localRedemptionPoints: 1,
      ecommerceRedemptionPoints: 1,
      invitePoints: 1
    },
    flags: {
      qrCodeScan: false,
      externalIds: false,
      globalDeals: false,
      skus: false,
      lightPartners: false
    }
  }

  public get whitelabel(): Whitelabel | undefined {
    return whitelabelModule.whitelabel
  }

  public get isSuperadmin(): boolean {
    return authModule.isSuperadmin
  }

  @Watch('form.flags.externalIds')
  handleExternalIdsFlagChange(newVal: boolean, oldVal: boolean) {
    if (newVal === oldVal) return
    if (!newVal) {
      this.form.flags.qrCodeScan = false
    }
  }

  @Watch('form.flags.qrCodeScan')
  handleQrCodeScanFlagChange(newVal: boolean, oldVal: boolean) {
    if (newVal === oldVal) return
    if (!newVal) {
      this.form.flags.lightPartners = false
    }
  }

  @Watch('form.name')
  public slugify(val: string): void {
    const a =
      'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b =
      'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz______'
    const p = new RegExp(a.split('').join('|'), 'g')

    this.form.slug = val
      .toString()
      .toLowerCase()
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '_und_') // Replace & with 'and'
      .replace(/\s+/g, '_') // Replace spaces with _
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/--+/g, '_') // Replace multiple - with single _
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  public async created(): Promise<void> {
    if (!this.edit) return
    if (authModule.isSuperadmin) {
      await whitelabelModule.fetch(this.$route.params.wid)
    }
    this.form = JSON.parse(JSON.stringify(this.whitelabel))
  }

  public async saveWhitelabel(): Promise<void> {
    if (!this.edit) {
      whitelabelModule.create(this.form)
    } else {
      const payload = await compareNested(this.form, this.whitelabel)
      Object.assign(payload, { _id: this.whitelabel!._id })
      whitelabelModule.update(payload)
    }
    document.dispatchEvent(new Event('close-whitelabel'))
  }
}

export default WhitelabelEditor
